import _ from 'lodash';

export const PropertyCorrelationMap = {
  propertyCity: 'city',
  propertyCounty: 'county',
  propertyState: 'state',
  propertyStreet: 'street',
  propertyUnit: 'unit',
  propertyZip: 'zip',
};

export const PendingCorrelationMap = _.invert({
  ...PropertyCorrelationMap,
  creditRating: 'creditScore',
  emailAddress: 'email',
  phoneNumber: 'cellPhoneNumber',
  occupancyType: 'occupancy',
  loanDownPayment: 'downPaymentValue',
  loanCashOutAmount: 'cashOutAmount',
});
